import type { ToastrService } from 'ngx-toastr';

/**
 * Accuracy (radius in metres) above which an auto-filled device position is treated as too coarse to
 * trust. A real GNSS fix at sea normally lands well inside this; much larger values usually mean the
 * position came from Wi-Fi or IP geolocation rather than GPS
 */
export const POSITION_ACCURACY_WARNING_METRES = 100;

/**
 * Warn the fisher when a position they just auto-filled is too coarse to rely on. Called from the
 * autofill handlers on each set screen, right after the coordinates and their accuracy are recorded.
 * @param toastr The calling component's toast service
 * @param accuracy Accuracy in metres recorded with the coordinates; undefined when no fix was captured
 * @returns Whether a warning was shown
 */
export function warnOnPoorPositionAccuracy(toastr: ToastrService, accuracy?: number): boolean {
    if (typeof accuracy !== 'number' || !isFinite(accuracy) || accuracy <= POSITION_ACCURACY_WARNING_METRES) {
        return false;
    }

    toastr.warning(
        `These coordinates are only accurate to about ${Math.round(accuracy)} m, so they may not be where you actually are. Check them against your vessel's GPS and correct them if needed.`,
        'Inaccurate Location',
        { timeOut: 10000, extendedTimeOut: 5000 },
    );
    return true;
}
